import * as React from 'react';
import TableContext from '../context/TableContext';
import ExpandedRow from './ExpandedRow';
import BodyContext from '../context/BodyContext';
import { getColumnsKey } from '../utils/valueUtil';
import ResizeContext from '../context/ResizeContext';
import BodyRow from './BodyRow';
import useFlattenRecords from '../hooks/useFlattenRecords';
import HoverContext from '../context/HoverContext';
import MeasureRow from './MeasureRow';
function Body({ data, getRowKey, measureColumnWidth, expandedKeys, onRow, rowExpandable, emptyNode, childrenColumnName }) {
    const { onColumnResize } = React.useContext(ResizeContext);
    const { prefixCls, getComponent } = React.useContext(TableContext);
    const { flattenColumns } = React.useContext(BodyContext);
    const flattenData = useFlattenRecords(data, childrenColumnName, expandedKeys, getRowKey);
    // ====================== Hover =======================
    const [startRow, setStartRow] = React.useState(-1);
    const [endRow, setEndRow] = React.useState(-1);
    const onHover = React.useCallback((start, end) => {
        setStartRow(start);
        setEndRow(end);
    }, []);
    const hoverContext = React.useMemo(() => ({ startRow, endRow, onHover }), [onHover, startRow, endRow]);
    // ====================== Render ======================
    const bodyNode = React.useMemo(() => {
        const WrapperComponent = getComponent(['body', 'wrapper'], 'tbody');
        const trComponent = getComponent(['body', 'row'], 'tr');
        const tdComponent = getComponent(['body', 'cell'], 'td');
        let rows;
        if (data.length) {
            rows = flattenData.map((item, idx) => {
                const { record, indent, index: renderIndex } = item;
                const key = getRowKey(record, idx);
                return (<BodyRow key={key} rowKey={key} record={record} recordKey={key} index={idx} renderIndex={renderIndex} rowComponent={trComponent} cellComponent={tdComponent} expandedKeys={expandedKeys} onRow={onRow} getRowKey={getRowKey} rowExpandable={rowExpandable} childrenColumnName={childrenColumnName} indent={indent}/>);
            });
        }
        else {
            rows = (<ExpandedRow expanded className={`${prefixCls}-placeholder`} prefixCls={prefixCls} component={trComponent} cellComponent={tdComponent} colSpan={flattenColumns.length} isEmpty>
                    {emptyNode}
                </ExpandedRow>);
        }
        const columnsKey = getColumnsKey(flattenColumns);
        return (<WrapperComponent className={`${prefixCls}-tbody`}>
                {/* Measure body column width with additional hidden col */}
                {measureColumnWidth && (<MeasureRow prefixCls={prefixCls} columnsKey={columnsKey} onColumnResize={onColumnResize}/>)}

                {rows}
            </WrapperComponent>);
    }, [
        data,
        prefixCls,
        onRow,
        measureColumnWidth,
        expandedKeys,
        getRowKey,
        getComponent,
        emptyNode,
        flattenColumns,
        childrenColumnName,
        onColumnResize,
        rowExpandable,
        flattenData
    ]);
    return <HoverContext.Provider value={hoverContext}>{bodyNode}</HoverContext.Provider>;
}
const MemoBody = React.memo(Body);
MemoBody.displayName = 'Body';
export default MemoBody;
